import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import subscriptionSlice from './slices/subscriptionSlice';
import githubSlice from './slices/githubSlice';
import uiSlice from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    subscription: subscriptionSlice,
    github: githubSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Type exports for development - will be properly typed later if TS is added
export default store;